// extracted by mini-css-extract-plugin
export default {"enterprisePage":"src-pages-enterprise-index-module_enterprisePage--zKgM6","tabContent":"src-pages-enterprise-index-module_tabContent--tx9Oc"};